import { IconNames } from '@shipengine/giger-theme';
import { Button, ButtonVariant, Icon } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

function ParcelTrackingTimelineDisplayButton(_ref) {
  let {
    open,
    onToggle,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation();
  return jsxs(Button, {
    variant: ButtonVariant.TEXT,
    onClick: () => onToggle(!open),
    ...otherProps,
    children: [jsx("span", {
      children: t('tracking-details.parcel.display-timeline')
    }), jsx(Icon, {
      name: open ? IconNames.CHEVRON_TOP : IconNames.CHEVRON_BOTTOM
    })]
  });
}

export { ParcelTrackingTimelineDisplayButton };
//# sourceMappingURL=ParcelTrackingTimelineDisplayButton.js.map
